import { useState } from 'react'

import { EMPTY_STRING } from '../../../../constants/common'
import { TextareaInlineField, TextareaSkeleton } from '../../../Textarea'
import { Container } from '../../Container'
import {
  TEXTAREAS_ERROR_TEXT,
  TEXTAREAS_HELP_TEXT,
  TEXTAREAS_INFO,
  TEXTAREAS_LABEL,
  TEXTAREAS_MAX_LENGTH,
  TEXTAREAS_MIN_ROWS,
  TEXTAREAS_PLACEHOLDER,
  TEXTAREAS_VALUE,
} from '../Textareas.constants'

import * as styles from './TextareasInline.module.css'

function TextareasInline() {
  const [value, setValue] = useState(EMPTY_STRING)

  function voidHandleChange() {
    return
  }

  return (
    <>
      <Container label='Fully testable textarea with auto resize, required, with help text, with info, with counter, height - 96px, min width - 160px'>
        <TextareaInlineField
          autoResizeHeight
          clearable
          required
          helpText={TEXTAREAS_HELP_TEXT}
          info={TEXTAREAS_INFO}
          label={TEXTAREAS_LABEL}
          maxLength={TEXTAREAS_MAX_LENGTH}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
          value={value}
          onChange={setValue}
        />
      </Container>
      <Container label='Textarea without resize button with auto resize height, min height - 96px, min width - 160px'>
        <TextareaInlineField
          autoResizeHeight
          withoutManualResize
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea without resize button and without auto resize height, min height - 96px, min width - 160px'>
        <TextareaInlineField
          withoutManualResize
          label={TEXTAREAS_LABEL}
          placeholder={TEXTAREAS_PLACEHOLDER}
        />
      </Container>
      <Container label='Textarea, with help text, disabled, with value, min height - 96px, min width - 160px'>
        <TextareaInlineField
          disabled
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
          value={TEXTAREAS_VALUE}
          onChange={voidHandleChange}
        />
      </Container>
      <Container label='Textarea, with help text, with error, with value, min height - 96px, min width - 160px'>
        <TextareaInlineField
          error={TEXTAREAS_ERROR_TEXT}
          helpText={TEXTAREAS_HELP_TEXT}
          label={TEXTAREAS_LABEL}
          minRows={TEXTAREAS_MIN_ROWS}
          placeholder={TEXTAREAS_PLACEHOLDER}
          value={TEXTAREAS_VALUE}
        />
      </Container>

      <Container label='Textarea skeleton'>
        <TextareaSkeleton
          className={styles.textareaSkeletonBox}
          textareaClassName={styles.textareaSkeleton}
        />
      </Container>
    </>
  )
}

export default TextareasInline
